import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "../../../../assets/colors/Colors";
import { modalCRUDService } from "../../../../services/modalCRUDService";
import InputForm from "../../../../components/ComponentesFormularios/InputForm";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidth, ERROREMAILFIELDREQUIRED, ERRORFIELDREQUIRED,
    optionsEstados,
} from "../../../../data/ConstantForm";
import SelectForm from "../../../../components/ComponentesFormularios/SelectForm";
import { CalendarForm } from "../../../../components/ComponentesFormularios/CalendarForm";
import ImagePicker from "../../../../components/ComponentesFormularios/ImagePicker";
import AutocompleteForm from "../../../../components/ComponentesFormularios/Autocomplete";
import { convertToString, getDateTime, validArray, validObjectKeys } from "../../../../util/functions";
import RadioButtonForm from "../../../../components/ComponentesFormularios/RadioButtonForm";
import { adminService } from "../../../../services/apiAdmin";
import { GlobalConstants } from "../../../../data/GlobalConstants";
import { isEmpty } from "../../../../util/is";
import { modalSideService } from "../../../../services/modalSideService";
import { ConstantsFormCrud } from "../../../../data/RoutesFormCrud";
import { productosService } from "../../../../services/apiProductos";
import SelectFormVirtualize from "../../../../components/ComponentesFormularios/SelectFormVirtualize";

const ComponentRoles = ({ className, roles, onChange }) => {

    const dispatch = useDispatch();
    const [state, setState] = useState(Object.assign({}, roles));
    const generalServicesState = useSelector(state => state.generalServices)

    const handleChangeRol = (item) => {

        if (isEmpty(state[item.id])) {
            setState({ ...state, [item.id]: { id: item.id, text: item.text } })
        }
        else {

            let obj = Object.assign({}, state);
            delete obj[item.id];
            setState(obj);

        }



    }

    const handleOpenDetailRol = (rol) => {

        adminService.getMenusByRol(rol.id).then(
            response => {

                const { status, msg, data } = response;

                if (status) {

                    modalSideService.showModal({
                        type: ConstantsFormCrud.modalShowDetailRoles,
                        props: { idRol: rol.id, nmRol: rol.text, data },
                        title: `Información del rol ${rol.id} (${rol.text})`,
                        isAddMode: false,
                        isEditable: false,
                        dense: true,
                        size: 'xl'
                    })

                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } });

                }
                else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                }

            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
            }
        )


    }

    useEffect(() => {
        onChange(state);
    }, [state])

    return (
        <div className="mx-2">
            <header className="mx-2 text-center text-muted content-divider divider-form">
                <span className="px-2" style={{ color: Colors.COLOR_SKY_THEME }}>Roles Usuario</span>
            </header>
            <div className="row mx-0 px-0 mb-2 mt-4" style={{ border: "1px dashed gray", borderRadius: 10 }}>
                <div className={className}>
                    {
                        generalServicesState?.arrRoles?.map((item, index) => (

                            <div key={`itemRol${item.id}${index}`} className="my-2 d-flex align-items-center">
                                <div onClick={() => handleOpenDetailRol(item)} className="w-50 text-overflow-card-punto-venta-oneline cursor-pointer"><span className="font-weight-bold" style={{ fontSize: 12 }}><u>{item.text}</u><span style={{ color: Colors.COLOR_BLUE_THEME }}> (Ver menus)</span></span></div>
                                <div className="w-50 text-right d-flex align-items-center justify-content-end">
                                    <i onClick={() => handleChangeRol(item)} style={{ color: state[item.id] ? Colors.GREEN_SWITCH_ACTIVE : Colors.DARK_GRAY, cursor: "pointer" }} className="far fa-check p-1" />
                                </div>
                            </div>

                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const Roles = () => {

    const { control, setValue, getValue } = useFormContext();

    const roles = useWatch({
        control,
        name: 'roles'
    })


    const onChangeRoles = (stateRoles) => {
        setValue("roles", stateRoles);
    }

    return (
        <ComponentRoles className={`px-3 py-2 col-12`} roles={roles} onChange={(stateRoles) => onChangeRoles(stateRoles)} />
    )

}


const FormUsuariosCRUD = ({ isEditing, isAddMode, properties }) => {

    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const generalServicesState = useSelector(state => state.generalServices);
    const authState = useSelector(state => state.auth);
    const { idUsuario } = authState;
    const methods = useForm({ defaultValues: Object.assign({}, data) });
    const { handleSubmit, control, formState: { errors }, getValues, setValue, register } = methods;

    const onSuccessSubmit = data => {

        let roles = [];

        for (let item in data.roles) {
            roles.push({
                nmRol: item
            })
        }


        data.roles = roles.slice();
        data.usrAuditoria = idUsuario;
        data.accion = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';

        let jsAgentesComerciales = [];
        for (let itemAC of data.agentesComerciales) {
            jsAgentesComerciales.push({
                nbAC: itemAC.id
            })
        }

        console.log(jsAgentesComerciales)
        data.agentesComerciales = jsAgentesComerciales.slice();
        data.jsItems = {
            arrRoles: data.roles,
            arrPropietarios: data.agentesComerciales,
        }

        adminService.setUsuariosCrud(data).then(
            response => {

                const { status, msg, data: datos } = response;

                if (status) {
                    if (datos?.idmsg === 200) {

                        if (isAddMode && isEditing) {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            tableRef.current.api.applyTransaction({
                                add: [{
                                    id: datos?.idreg,
                                    estado: data?.estado,
                                    nombre: data?.nombre,
                                    perfil: data?.perfil,
                                    grupo: data?.grupo,
                                    correo: data?.correo,
                                    celular: data?.celular,
                                    proxCambioPw: data?.proxCambioPw,
                                    usrAuditoria: data?.usrAuditoria,
                                    fechaAuditoria: getDateTime(),
                                    PWD: true
                                }]
                            })
                        }
                        else {

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            const rowNode = params.api.getRowNode(params.node.id);

                            rowNode.setDataValue("estado", data?.estado);
                            rowNode.setDataValue("nombre", data?.nombre);
                            rowNode.setDataValue("perfil", data?.perfil);
                            rowNode.setDataValue("grupo", data?.grupo);
                            rowNode.setDataValue("correo", data?.correo);
                            rowNode.setDataValue("celular", data?.celular);
                            rowNode.setDataValue("proxCambioPw", data?.proxCambioPw);
                            rowNode.setDataValue("usrAuditoria", data?.usrAuditoria);
                            rowNode.setDataValue("fechaAuditoria", getDateTime());

                        }

                        modalCRUDService.clear();
                    }
                    else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.txmsg } });
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } });
                }


            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: error.toString() } });
            }
        );

    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    useEffect(() => {
        register("roles", { validate: value => !isEmpty(value) || 'Este Campo es requerido' })
    }, [])

    return (
        <FormProvider {...methods} >
            <div className="d-flex justify-content-end align-items-center">
                {isEditing &&
                    <Tooltip title="Guardar" aria-label="guardar">
                        <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                            className="icon-container-actions d-flex">
                            <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                            <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                        </a>
                    </Tooltip>
                }
                <Tooltip title="Cancelar" aria-label="cancelar">
                    <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                        <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                        <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                    </a>
                </Tooltip>
            </div>
            <div className="container mx-0 px-0 w-100 mw-100 my-3">
                <div className="mx-2 text-center text-muted content-divider divider-form">
                    <span className="px-2" style={{ color: Colors.COLOR_SKY_THEME }}>Información Usuario</span>
                </div>
                <div className="row mx-0 px-0 my-4">

                    <InputForm inputProps={{ control }} readOnly={!isAddMode} disabled={!isEditing} identificador="usuario" label="Usuario"
                        placeholder="Ej: C1095542334" type="text" required={true} className={`${classResponsiveForm}`}
                        customError={errors.usuario ? ERRORFIELDREQUIRED : null} />

                    <SelectForm inputProps={{ control }} disabled={!isEditing} identificador="perfil" label="Perfil"
                        options={validArray(generalServicesState?.arrPerfiles)} required={true} className={`${classResponsiveForm}`}
                        customError={errors.perfil ? ERRORFIELDREQUIRED : null} />

                    <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="agentesComerciales" label="Agente Comercial"
                        options={validArray(generalServicesState?.arrEmpresas)} required={true} className={`${classResponsiveFormDoubleWidth}`}
                        customError={errors.agentesComerciales ? ERRORFIELDREQUIRED : null} isMulti={true} />

                    <InputForm inputProps={{ control }} disabled={!isEditing} identificador="nombre" label="Nombre"
                        placeholder="Ej: Antonio Perez" type="text" required={true} className={`${classResponsiveFormDoubleWidth}`}
                        customError={errors.nombre ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} disabled={!isEditing} identificador="celular" label="Celular"
                        placeholder="Ej: Antonio Perez" type="text" required={true} className={`${classResponsiveForm}`}
                        customError={errors.celular ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} disabled={!isEditing} identificador="grupo" label="Grupo"
                        placeholder="Ej: 1" type="text" required={true} className={`${classResponsiveForm}`}
                        customError={errors.grupo ? ERRORFIELDREQUIRED : null} />

                    <InputForm inputProps={{ control }} disabled={!isEditing} identificador="correo" label="Correo Electrónico"
                        placeholder="Ej: test@hotmail.com" type="text" required={true} className={`${classResponsiveFormDoubleWidth}`}
                        customError={errors.correo ? ERROREMAILFIELDREQUIRED : null} rules={{ pattern: { value: /\S+@\S+\.\S+/ } }} />

                    <CalendarForm inputProps={{ control }} disabled={!isEditing} identificador="proxCambioPw" label="Fecha Cambio Contraseña"
                        required={true} className={`${classResponsiveForm}`} rules={{ pattern: { value: /\S+@\S+\.\S+/ } }}
                        customError={errors.proxCambioPw ? ERROREMAILFIELDREQUIRED : null} />

                    <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                        defaultValue="1" label="Estado" className={`${classResponsiveForm}`}
                        customError={errors.estado ? ERRORFIELDREQUIRED : null} />


                    <ImagePicker inputProps={{ control }} label="Avatar" required={true} disabled={!isEditing} identificador="avatar"
                        className="px-2 col-12" customError={errors.avatar ? ERRORFIELDREQUIRED : null} />


                </div>

                <Roles />





            </div>

        </FormProvider>
    )
}

export default FormUsuariosCRUD;
